import { FormattedMessage } from 'react-intl';

import { Box } from '@mui/material';

import { NavItemType } from '@trendiolive/trendio-selfcare-ui-kit';

import { CommentOutlined } from '@ant-design/icons';

export const crm: NavItemType = {
  id: 'crm-menu',
  type: 'group',
  children: [
    {
      id: 'crm',
      title: <FormattedMessage id="crm" />,
      type: 'collapse',
      icon: CommentOutlined,
      children: [
        {
          id: 'create-sequence',
          title: (
            <Box sx={{ textTransform: 'capitalize' }}>
              <FormattedMessage id="create-sequence" />
            </Box>
          ),
          type: 'item',
          url: '/crm/create-sequence'
        },
        {
          id: 'my-sequences',
          title: <FormattedMessage id="my-sequences" />,
          type: 'item',
          url: '/crm/my-sequences'
        },
        {
          id: 'my-templates',
          title: <FormattedMessage id="my-templates" />,
          type: 'item',
          url: '/crm/my-templates'
        }
      ]
    }
  ]
};
